import Utils from '../../utils/Utils';
import * as constant from '../constants';
import Device from './../../devices/device';
import { constants } from 'zlib';
import settings from './../../devices/all/settings';

class PlayerHelper {

    /**
     * Verifica si es el mismo contenido a playear:
     * Si llegó aquí es probable que el current content type es el mismo que el siguiente content type (esta en vod y sigue en vod, o esta en timeshift y quiere seguir en timeshift)
     */
    static sameMediaContent(currentPlayingOptions, nextPlayingOptions, nextContentType) {
        // Para probar si es el mismo, no se considera size, backgroundimage, duration y/o playerstate
        let sameSource = false;

        // Si hay source, hay algo que comparar/revisar
        if(currentPlayingOptions.source && nextPlayingOptions.source) {
            // Primera prioridad videoid
            if(!Utils.isNullOrUndefined(currentPlayingOptions.source.videoid)) {
                if(!Utils.isNullOrUndefined(nextPlayingOptions.source.videoid)) {

                    sameSource = PlayerHelper.isEqual(parseInt(currentPlayingOptions.source.videoid), parseInt(nextPlayingOptions.source.videoid));

                    // Si es mismo group id, puede ser startOver (pasan de live a startover)
                    const currentContentType = PlayerHelper.getContentType(currentPlayingOptions);
                    if(!nextContentType)
                        nextContentType = PlayerHelper.getContentType(nextPlayingOptions);
                    if(currentContentType !== nextContentType)    {
                        sameSource = false;

                        return sameSource; // Nada que hacer si son diferentes streamContentType
                    }

                    // Si es el same source, tal ves es un replace de un single a un single o de un multiple a un multiple
                    if(sameSource) {
                        // Verificar los lenguajes
                        // TODO verificar mismo objeto!!, live siempre será dif group id
                        // OJO AQUI, SAME SOURCE ES TRUE!!
                        switch(nextContentType) {
                            // Cambio entre vods
                            case constant.AAF_CONTENT_IS_VOD:
                                if(!currentPlayingOptions.languageoptions && nextPlayingOptions.languageoptions) {
                                    sameSource = false;
                                }
                                if(currentPlayingOptions.languageoptions && !nextPlayingOptions.languageoptions) {
                                    sameSource = false;
                                }
                                if(sameSource) {
                                    // current lang, ya seleccionado
                                    if(currentPlayingOptions.languageoptionid !== nextPlayingOptions.languageoptionid) {
                                        sameSource = false;
                                    }
                                }
                            break;
                            // Cambio entre catchups
                            case constant.AAF_CONTENT_IS_STARTOVER:
                                sameSource = (currentPlayingOptions.starttime === nextPlayingOptions.starttime) && (currentPlayingOptions.endtime === nextPlayingOptions.endtime);
                            break;    
                            case constant.AAF_CONTENT_IS_CATCHUP:
                                sameSource = (currentPlayingOptions.starttime === nextPlayingOptions.starttime) && (currentPlayingOptions.endtime === nextPlayingOptions.endtime);
                                if(!sameSource) {
                                    // Mismo evento?
                                    if(currentPlayingOptions 
                                        && currentPlayingOptions.event
                                        && currentPlayingOptions.event.id
                                        && nextPlayingOptions.event
                                        && nextPlayingOptions.event.id
                                        && currentPlayingOptions.event.id === nextPlayingOptions.event.id
                                        ) {
                                            sameSource = true;
                                        }
                                }
                            break;
                            // Cambio entre timeshift
                            case constant.AAF_CONTENT_IS_TIMESHIFT:
                                sameSource = currentPlayingOptions.starttime === nextPlayingOptions.starttime;
                            break;
                            /**
                             * Si es TV y es el mismo group_id, es fallback? para forzar a que intente playing del mismo group id pero con diferente stream type
                             * */    
                            case constant.AAF_CONTENT_IS_TV:
                                    if(!currentPlayingOptions.deleteLastStream && nextPlayingOptions.deleteLastStream) {
                                        sameSource = false;
                                    }
                                    if(currentPlayingOptions.deleteLastStream && !nextPlayingOptions.deleteLastStream) {
                                        sameSource = false;
                                    }
                                    if(sameSource) {
                                        if(currentPlayingOptions.deleteLastStream && nextPlayingOptions.deleteLastStream) {
                                            if(currentPlayingOptions.deleteLastStream.length !== nextPlayingOptions.deleteLastStream.length) {
                                                sameSource = false;
                                            }
                                        }
                                    }
                            break;
                            default: break;
                        }

                    }
                }
            }

            // Después videosource
            if(!sameSource) {
                if(!Utils.isNullOrUndefined(currentPlayingOptions.source.videosource)) {
                    if(!Utils.isNullOrUndefined(nextPlayingOptions.source.videosource)) {
                        sameSource = PlayerHelper.isEqual(currentPlayingOptions.source.videosource, nextPlayingOptions.source.videosource);
                    }
                    // Si es el same source, tal ves es un replace de un single a un single o de un multiple a un multiple
                    if (sameSource) {
                        // Verificar los lenguajes
                        // TODO verificar mismo objeto!!
                        if (!currentPlayingOptions.languageoptions && !nextPlayingOptions.languageoptions) {
                            sameSource = false;
                        }
                        if (currentPlayingOptions.languageoptions && nextPlayingOptions.languageoptions) {
                            sameSource = false;
                        }
                    }


                }
            }

            // Después audiosource
            if(!sameSource) {
                if(!Utils.isNullOrUndefined(currentPlayingOptions.source.audiosource)) {
                    if(!Utils.isNullOrUndefined(nextPlayingOptions.source.audiosource)) {
                        sameSource = PlayerHelper.isEqual(currentPlayingOptions.source.audiosource, nextPlayingOptions.source.audiosource);
                    }
                }
            }
        }

        return sameSource;
    }

    static isFallback(currentPlayingOptions, nextPlayingOptions, nextContentType) {

        if(nextPlayingOptions && nextPlayingOptions.isFallback) {
            return true;
        }
        let isFallback = false;
        let sameSource = false;
        let isTv = nextContentType === constant.AAF_CONTENT_IS_TV;
        
        if(currentPlayingOptions && currentPlayingOptions.source && nextPlayingOptions && nextPlayingOptions.source ) {
            if(!Utils.isNullOrUndefined(currentPlayingOptions.source.videoid) && !Utils.isNullOrUndefined(nextPlayingOptions.source.videoid)) {
                sameSource = PlayerHelper.isEqual(parseInt(currentPlayingOptions.source.videoid), parseInt(nextPlayingOptions.source.videoid));
            }
        }
      
        if(isTv && sameSource) {
            if(!currentPlayingOptions.deleteLastStream && nextPlayingOptions.deleteLastStream) {
                isFallback = true;
            }
            if(currentPlayingOptions.deleteLastStream && !nextPlayingOptions.deleteLastStream) {
                isFallback = true;
            }
            if(!isFallback) {
                if(currentPlayingOptions.deleteLastStream && nextPlayingOptions.deleteLastStream) {
                    if(currentPlayingOptions.deleteLastStream.length !== nextPlayingOptions.deleteLastStream.length) {
                        isFallback = true;
                    }
                }
            }
        }
        return isFallback;
    }

    /**
     * strict equal
     */
    static isEqual(param1, param2) {
        return param1 === param2;
    }

    /**
     * Recuperar el tipo de contenido que se va a playear basado en las opciones que vienen desde el dispatch
     * options son los params del dispatch
     */
    static getContentType(options) {
        // Ordenado por prioridad...
        let contentType = null;

        contentType = PlayerHelper.contentIsNPVR(options) ? constant.AAF_CONTENT_IS_NPVR : null;

        if(!contentType) {
          contentType = PlayerHelper.contentIsVOD(options) ? constant.AAF_CONTENT_IS_VOD : null;
        }

        if(!contentType) {
            contentType = PlayerHelper.contentIsTV(options) ? constant.AAF_CONTENT_IS_TV : null;
        }

        if(!contentType) {
            contentType = PlayerHelper.contentIsCatchup(options) ? constant.AAF_CONTENT_IS_CATCHUP : null;
        }

        if(!contentType) {
            contentType = PlayerHelper.contentIsStartOver(options) ? constant.AAF_CONTENT_IS_STARTOVER : null;
        }

        if(!contentType) {
            contentType = PlayerHelper.contentIsTimeshift(options) ? constant.AAF_CONTENT_IS_TIMESHIFT : null;
        }

        if(!contentType) {
            contentType = PlayerHelper.contentIsAudio(options) ? constant.AAF_CONTENT_IS_AUDIO : null;
        }

        if(!contentType) {
            contentType = PlayerHelper.contentIsRadio(options) ? constant.AAF_CONTENT_IS_RADIO : null;
        }

        return contentType;
    }

    static  contentIsNPVR(options){
      return options.source &&options.source.videosource && options.source.videosource.indexOf('record_token')!==-1;
    }

    static contentIsVOD(options) {
        let hasStartTimeEndTime = Utils.isNotNullOrNotUndefined(options.starttime) && Utils.isNotNullOrNotUndefined(options.endtime); 
        return !hasStartTimeEndTime && options.source  && (options.source.videoid || options.source.videosource) && options.islive === false;
    }

    static contentIsTV(options) {
        return options.source  && (options.source.videoid || options.source.videosource) && options.islive === true && !options.starttime && !options.endtime;
    }

    static contentIsCatchup(options) {
        let isStartOver = Utils.isNotNullOrNotUndefined(options.isStartOver) && options.isStartOver === true;
        return !isStartOver && options.source && (options.source.videoid || options.source.videosource) && options.starttime && options.endtime;
    }

    static contentIsStartOver(options) {
        let isStartOver = Utils.isNotNullOrNotUndefined(options.isStartOver) && options.isStartOver === true;
        return isStartOver && options.source && (options.source.videoid || options.source.videosource) && options.starttime && options.endtime;
    }

    static contentIsTimeshift(options) {
        return options.source && (options.source.videoid || options.source.videosource) && options.islive === true && options.starttime && !options.endtime;
    }

    static contentIsAudio(options) {
        return options.source && options.source.audiosource && !options.source.videosource && !options.source.videoid && options.islive === false;
    }

    static contentIsRadio(options) {
        return options.source && options.source.audiosource && !options.source.videosource && !options.source.videoid && options.islive === true;
    }

    /**
     * Console log
     */
    static log(message, messageType = null) {
        let prepend = '[AAFPLayer] ';
        message = prepend + message;

        switch (messageType) {
            case constant.LOG_INFO:
                console.info(message);
                break;
            case constant.LOG_ERROR:
                console.error(message);
                break;
            case constant.LOG_WARNING:
                console.warning(message);
                break;
            case constant.LOG_BASIC:
            default:
                console.log(message);
                break;
        }
    }

    // TODO test test test este método
    static getVideoType(url) {
        let mediaType = null;
        url = url.toLowerCase();

        if(/^udp:(.)+/g.test(url)) {
            mediaType = constant.IP_MULTICAST_UDP;
        }

        if(/octoshape/i.test(url)) {
            mediaType = constant.IP_MULTICAST;
        }

        if(/.manifest.|.manifest$/i.test(url)) {
            mediaType = constant.SS;
        }

        if (/.mp4\?|\.mp4$/i.test(url)) {
            mediaType = constant.AUDIO;
        }

        // Hay forma de diferenciar hls hlskr hlsprm ¿?
        if (/.m3u8\?|\.m3u8$/i.test(url)) {
            mediaType = constant.HLS;
        }

        if (/.mp3\?|\.mp3$/i.test(url)) {
            mediaType = constant.AUDIO;
        }

        if (/tv:\/\/./i.test(url)) {
            mediaType = constant.DVBC;
        }

        // Si es zero-index, DVBS
        if (!isNaN) {
            mediaType = constant.DVBS;
        }

        return mediaType;
        // Todo agregar, TypeID para musica
    }

    /**
     * TODO catchup debería ser vod ¿?
     * @param supportedStreams desde device config, después desde apa
     */
    static getVideoMultiples(supportedStreams) {
      let multiples = supportedStreams.filter(stream => stream.includes(settings.prepend_multiple));
      return multiples;
    }

    static getVideoSingle(supportedStreams) {
      let multiples = supportedStreams.filter(stream => !stream.includes(settings.prepend_multiple));
      return multiples;
    }

    static getMultipleOptionForStreamingType(singleStreamingType) {
        switch(singleStreamingType) {
            case constant.SS:
                return constant.SS_MA;
            break;
            case constant.HLSPRM:
                return constant.HLSPRM;
            break;
            // Para chafari
            case constant.HLS:
                return constant.HLS_MA;
            break;
            default:
                return null;
            break;
        }
    }

    static isPGMErrorStreamType(pgm_response) {
        let ret = false;
        if(pgm_response && pgm_response.errors) {
            if(pgm_response.errors[0] && pgm_response.errors[0].code) {
                if(pgm_response.errors[0].code === constant.PLY_PLY_00009
                    || pgm_response.errors[0].code === constant.PLY_TIMEOUT
                    || pgm_response.errors[0].code === constant.PLY_PLY_00001) {
                        ret = true;
                    }
            }
        }

        return ret;
    }

    static getProviderFromPgm(pgm) {
        let provider = '';
        if(pgm.group && pgm.group.common && pgm.group.common.extendedcommon && pgm.group.common.extendedcommon.media && pgm.group.common.extendedcommon.media.proveedor) {
            provider = pgm.group.common.extendedcommon.media.proveedor.nombre;
        }

        return provider;
    }

    static getProviderCodeFromPgm(pgm) {
        let provider = '';
        if(pgm.group && pgm.group.common && pgm.group.common.extendedcommon && pgm.group.common.extendedcommon.media && pgm.group.common.extendedcommon.media.proveedor) {
            provider = pgm.group.common.extendedcommon.media.proveedor.codigo;
        }

        return provider;
    }

    static ifMultipleStreamExists(nextContentType, availablestreams) {
        let contentType = null;
        let supportedStreams = null;
        let device_config = Device.getDevice().getConfig();
        let supportedMultipleAudio = device_config.multipleaudio;
        let platform = Device.getDevice().getPlatform();
        let supported_stream_types = Utils.getApaSupportedStream(platform);

        switch(nextContentType) {
            case constant.AAF_CONTENT_IS_VOD:
                supportedStreams = supported_stream_types['vod'];
                contentType = 'vod';
            break;
            case constant.AAF_CONTENT_IS_TV:
                supportedStreams = supported_stream_types['live'];
                contentType = 'live';
            break;
            case constant.AAF_CONTENT_IS_STARTOVER:
            case constant.AAF_CONTENT_IS_TIMESHIFT:
                supportedStreams = supported_stream_types['timeshift'];
                contentType = 'timeshift';
            break;
            case constant.AAF_CONTENT_IS_CATCHUP:
                supportedStreams = supported_stream_types['vod'];
                contentType = 'vod';
            break;
            default:
            break;
        }

        if(contentType && supportedStreams && availablestreams.length > 0)
        {
            // Revisar sólo por los múltiples
            let multiple = PlayerHelper.getVideoMultiples(supportedStreams);
            for(let i = 0; i < multiple.length; i++) {
              if(availablestreams.indexOf(multiple[i]) !== -1) {
                    return multiple[i];
                }
            }
        }
    console.log('000 Return ifMultipleStreamExists:', null);
        return null;
    }

  static ifSingleStreamExists(nextContentType, availablestreams) {
        let contentType = null;
        let supportedStreams = null;

        let platform = Device.getDevice().getPlatform();
        let supported_stream_types = Utils.getApaSupportedStream(platform);


        switch(nextContentType) {
            case constant.AAF_CONTENT_IS_VOD:
                //supportedStreams = device_config.supported_stream_types['vod'];// ie. [SS, HLS];
                supportedStreams = supported_stream_types['vod'].filter(stream => !stream.includes(settings.prepend_multiple));
                contentType = 'vod';
            break;
            case constant.AAF_CONTENT_IS_TV:
                //supportedStreams = device_config.supported_stream_types['live'];// ie [SS];
                supportedStreams = supported_stream_types['live'].filter(stream => !stream.includes(settings.prepend_multiple));
                contentType = 'live';
            break;
            case constant.AAF_CONTENT_IS_TIMESHIFT:
                //supportedStreams = device_config.supported_stream_types['timeshift']; // = [SS, HLS];
                supportedStreams = supported_stream_types['timeshift'].filter(stream => !stream.includes(settings.prepend_multiple));
                contentType = 'timeshift';
            break;
            case constant.AAF_CONTENT_IS_CATCHUP:
                //supportedStreams = device_config.supported_stream_types['vod']; // ie. [SS, HLS];
                supportedStreams = supported_stream_types['vod'].filter(stream => !stream.includes(settings.prepend_multiple));
                contentType = 'vod';
            break;
            default:
            break;
        }

        if(contentType && supportedStreams && availablestreams.length > 0)
        {
            // Revisar sólo por los soportados
            for(let i = 0; i < supportedStreams.length; i++) {
                if(availablestreams.indexOf(supportedStreams[i]) !== -1) {
                    return supportedStreams[i];
                }
            }
        }

        return null;
    }
    // V2 reloaded
    static getLiveURL(gid, deviceSupportedLiveStreams) {
        let fastPlayObject = null;
        //console.info('***************************************************> [AAF] [PlayerHelper] getLiveUrl 1');

        if(!Array.isArray(deviceSupportedLiveStreams)) {
            return null;
        }
        if(deviceSupportedLiveStreams.length < 1) {
            return null;
        } 
        if(!gid) {
            return null;
        }
        //console.info('***************************************************> [AAF] [PlayerHelper] getLiveUrl 2');
        let cachedChannelData = Utils.getLiveStreamURL(gid);
        //console.info('***************************************************> [AAF] [PlayerHelper] getLiveUrl 2');
        if(cachedChannelData) {
            // hay opciones de fast_play?
            if(cachedChannelData && cachedChannelData.fast_play && Utils.isObject(cachedChannelData.fast_play)) {
                for(let j = 0; j < deviceSupportedLiveStreams.length; j++) {
                    if(typeof cachedChannelData.fast_play[deviceSupportedLiveStreams[j]] !== 'undefined') {
                        fastPlayObject = cachedChannelData;
                        fastPlayObject.streamType = deviceSupportedLiveStreams[j];
                        const supportedFastPlay = cachedChannelData.fast_play[deviceSupportedLiveStreams[j]];
                        if(Utils.isObject(supportedFastPlay)) {
                            fastPlayObject.live_url = supportedFastPlay.video_url;
                            fastPlayObject.server_url = supportedFastPlay.server_url;
                            fastPlayObject.challenge = supportedFastPlay.challenge;
                            fastPlayObject.certificate_url = supportedFastPlay.certificate_url;
                        } else {
                            fastPlayObject.live_url = cachedChannelData.fast_play[deviceSupportedLiveStreams[j]];
                        }
                        console.info('***************************************************> [AAF] [PlayerHelper] resolved FAST_PLAY live url and streamtype and iterate: ', fastPlayObject.live_url, fastPlayObject.streamType, j);
                        break;
                    }
                }
            }
        }
        
        return fastPlayObject;
    }

    static getAudioSubtitlesByGroupId (gid){
        const options = Utils.getAudioLangByGroupId(gid);
        return {
            audio: (options && options.audio) ? options.audio : null,
            subtitle: (options && options.subtitle) ? options.subtitle : null,
        }
    }

    // V1, obsoleto
    static getLiveURL2(gid, streams) {
        //console.info('=================================> [AAF] [PlayerHelper] enter en getLiveURL, gid, stream: ', gid, streams);
        // Settear/ajustar la url desde el attr fast_play de epg/channel & metadata=full
        Utils.setLiveURLFromFastPlay(gid, streams);
        let stream_url = null;
        for(let j = 0; j < streams.length; j++) {
            let url = PlayerHelper.getChannelURL(gid, streams[j]);
           //console.info('=================================> [AAF] [PlayerHelper] getLiveURL, en el for---> ', streams[j], ' encuentra URL ---> ', url);
            if(url) {
                stream_url = url;
                stream_url.streamType = streams[j];
                break;
            }
        }

        return stream_url;
    }
    /**
     * Por el momento sólo multicast y udp se recuperan desde la epg/channel
     */
    static getChannelURL(gid, streamType) {
        //let obj1 = Utils.getLiveStreamURL(gid);
        //console.info('=================================> [AAF] [PlayerHelper] getChannelURL obj1: ', obj1, obj1.live_url, obj1.fast_play);
        //console.info('=================================> [AAF] [PlayerHelper] getChannelURL obj1: ', obj1);
        let url = null;
        let _url = null;
        switch(streamType) {
            case constant.IP_MULTICAST_UDP:
            _url = Utils.getLiveStreamURL(gid);
            if(_url) {
                // URL realmente es udp?
                let re = /^udp:(.)+/g;
                if(re.test(_url.live_url)) {
                    url = _url;
                }
            }
            break;
            case constant.IP_MULTICAST:
            _url = Utils.getLiveStreamURL(gid);
            if(_url) {
                // URL realmente es octoshape?
                let re = /^octoshape:(.)+/g;
                if(re.test(_url.live_url)) {
                    url = _url;
                }
            }
            break;
            case constant.IP_MULTICAST_LMS:
               url = Utils.getLiveStreamURL(gid)
            break;
            default:
               url = null;
            break;
        }

        return url;
    }
}

export default PlayerHelper;


/*
Ejemplo PGM recording:
http://microfwk-tv2sony-test.clarovideo.net/services/player/getmedia?device_category=tv&device_manufacturer=sony&device_model=sony&device_type=tv&device_id=049dd27b-1113-f886-b235-86e44906ba33&api_version=v5.8&region=mexico&authpn=amco&authpt=12e4i8l6a581a&HKS=l8elk9sdnvi6f550a9shfrsua2&user_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1MTY5MjkxNjIsImV4cCI6MTUyMjExMzE2MiwidXNyIjp7InVzZXJfaWQiOiIyMTc5MjM5MyIsInVzZXJuYW1lIjoianNhbmNoZXpfZXh0QGFtY28ubXgiLCJlbWFpbCI6ImpzYW5jaGV6X2V4dEBhbWNvLm14IiwiZmlyc3RuYW1lIjoiYWFhYXRlc3QiLCJsYXN0bmFtZSI6ImFhYWFhdGVzdCIsImNvdW50cnlfY29kZSI6Ik1YIiwicmVnaW9uIjoibWV4aWNvIiwiYWNjZXB0ZWRfdGVybXMiOjF9fQ.e8aphpdK-3uyW_KEYIAi6h9Mqplfbvgnd4HNWu2ssBo&stream_type=smooth_streaming&record_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ2aWRlb191cmwiOiJcL3ZpZGVvXC9zM1wvdGVzdF9jbGFyb3ZpZGVvXzU0MTAwMjQ5NjY4MTYwMDAwLmlzbVwvTWFuaWZlc3QiLCJncm91cF9pZCI6NzQxNjg0LCJsaXZlcmVmIjoiZm94MWhkc3ViIiwiZHVyYXRpb24iOjMzMDAsInJlc291cmNlSWQiOiJjYXB0dXJldGVzdCIsInByb3ZpZGVySWQiOiJoYXJtb25pY3MiLCJyZWNvcmRlcklkIjoiY2FwdHVyZSJ9.nEY7GPYYCGKOCud9mfuZjf5ZfQ9fkAznGeRgibF5Tvw%3F

{
    entry: {
        device_category: "tv",
        device_manufacturer: "sony",
        device_model: "sony",
        device_type: "tv",
        device_id: "049dd27b-1113-f886-b235-86e44906ba33",
        api_version: "v5.8",
        region: "mexico",
        authpn: "amco",
        authpt: "12e4i8l6a581a",
        HKS: "l8elk9sdnvi6f550a9shfrsua2",
        user_token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1MTY5MjkxNjIsImV4cCI6MTUyMjExMzE2MiwidXNyIjp7InVzZXJfaWQiOiIyMTc5MjM5MyIsInVzZXJuYW1lIjoianNhbmNoZXpfZXh0QGFtY28ubXgiLCJlbWFpbCI6ImpzYW5jaGV6X2V4dEBhbWNvLm14IiwiZmlyc3RuYW1lIjoiYWFhYXRlc3QiLCJsYXN0bmFtZSI6ImFhYWFhdGVzdCIsImNvdW50cnlfY29kZSI6Ik1YIiwicmVnaW9uIjoibWV4aWNvIiwiYWNjZXB0ZWRfdGVybXMiOjF9fQ.e8aphpdK-3uyW_KEYIAi6h9Mqplfbvgnd4HNWu2ssBo",
        stream_type: "smooth_streaming",
        record_token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ2aWRlb191cmwiOiJcL3ZpZGVvXC9zM1wvdGVzdF9jbGFyb3ZpZGVvXzU0MTAwMjQ5NjY4MTYwMDAwLmlzbVwvTWFuaWZlc3QiLCJncm91cF9pZCI6NzQxNjg0LCJsaXZlcmVmIjoiZm94MWhkc3ViIiwiZHVyYXRpb24iOjMzMDAsInJlc291cmNlSWQiOiJjYXB0dXJldGVzdCIsInByb3ZpZGVySWQiOiJoYXJtb25pY3MiLCJyZWNvcmRlcklkIjoiY2FwdHVyZSJ9.nEY7GPYYCGKOCud9mfuZjf5ZfQ9fkAznGeRgibF5Tvw?"
    },
    status: 200,
    response: {
        stream_uuid: "cc92598f-970e-4a3f-a0d2-3d91e61bd787",
        media: {
            video_url: "https://capture-origin-vod-test.clarovideo.net/video/s3/test_clarovideo_54100249668160000.ism/Manifest",
            server_url: "https://playready-live-test.clarovideo.net/rightsmanager.asmx",
            challenge: "{"token":"0a7cb0de6df7a433cadc7ac5e6cb6b5d","material_id":null}",
            analytics_url: "https://capture-origin-vod-test.clarovideo.net/serverip"
        },
        user: {
            parental_rating: {
                requires_validation: false
            },
            first_view: {
                enabled: false
            }
        }
    }
}


Ejemplo PGM catchup:
http://mfwkstbhuawei-api.clarovideo.net/services/player/getmedia?group_id=762265&stream_type=hls&preview=0&startTime=15190444800000000&endTime=15190473600000000&HKS=fo4dpu6cva71cctv68hju27ru2&api_version=v5.8&authpn=amco&authpt=12e4i8l6a581a&device_category=stb&device_manufacturer=huawei&device_model=EC6108V9&device_type=ptv&device_id=2153017310HYGA500093&device_name=EC6108V9&device_so=Android%204.4.2&region=argentina&format=json


Ejemplo PGM timeshift:
http://mfwkstbhuawei-api.clarovideo.net/services/player/getmedia?group_id=762265&stream_type=hls&preview=0&startTime=15190444800000000&HKS=fo4dpu6cva71cctv68hju27ru2&api_version=v5.8&authpn=amco&authpt=12e4i8l6a581a&device_category=stb&device_manufacturer=huawei&device_model=EC6108V9&device_type=ptv&device_id=2153017310HYGA500093&device_name=EC6108V9&device_so=Android%204.4.2&region=argentina&format=json


Ejemplo PGM VOD:


Ejemplo PGM TV IP/Live:


*/



// WEBPACK FOOTER //
// ./src/AAFPlayer/helpers/PlayerHelper.js